
export default [
    {
        id: 1,
        name: 'Basil',
        latin: 'Ocimum basilicum',
        price: 9,
        category: 'Herbs',
        description: 'Basil also called great basil, is a culinary herb of the family Lamiaceae (mints). It is a tender plant, and is used in cuisines worldwide.'
    },
    {
        id: 2,
        name: 'Coriander',
        latin: 'Coriandrum sativum',
        price: 9,
        category: 'Herbs',
        description: 'Coriander is an annual herb in the family Apiaceae. It is also known as Chinese parsley, dhania, kothmir, or cilantro.'
    },
    {
        id: 3,
        name: 'Dill',
        latin: 'Anethum graveolens',
        price: 9,
        category: 'Herbs',
        description: 'Dill (Anethum graveolens) is an annual herb in the celery family Apiaceae. It is the only species in the genus Anethum.'
    },
    {
        id: 4,
        name: 'Mint',
        latin: 'Mentha',
        price: 9,
        category: 'Herbs',
        description: 'Mentha arvensis, the corn mint, field mint, or wild mint, is a species of flowering plant in the mint family Lamiaceae.'
    },
    {
        id: 5,
        name: 'Oregano',
        latin: 'Origanum vulgare',
        price: 9,
        category: 'Herbs',
        description: 'Oregano is the common name for a perennial herbaceous plant, Origanum vulgare of the mint family (Lamiaceae), characterized by opposite, aromatic leaves.'
    },
    {
        id: 6,
        name: 'Parsley',
        latin: 'Petroselinum crispum',
        price: 9,
        category: 'Herbs',
        description: 'Parsley, (Petroselinum crispum), hardy biennial herb of the carrot family (also called parsley family; Apiaceae).'
    },
    {
        id: 7,
        name: 'Rosemary',
        latin: 'Salvia rosmarinus',
        price: 9,
        category: 'Herbs',
        description: 'Salvia rosmarinus, commonly known as rosemary, is a shrub with fragrant, evergreen, needle-like leaves and white, pink, purple, or blue flowers.'
    },
    {
        id: 8,
        name: 'Thyme',
        latin: 'Thymus vulgaris',
        price: 9,
        category: 'Herbs',
        description: 'Thymes are relatives of the oregano genus Origanum, with both plants being mostly indigenous to the Mediterranean region.'
    },
    {
        id: 9,
        name: 'Cloves',
        latin: 'Syzygium aromaticum',
        price: 9,
        category: 'Herbs',
        description: 'Native to the Spice Islands near China, cloves spread throughout Europe and Asia during the late Middle Ages as an important part of local cuisine.'
    },
    {
        id: 10,
        name: 'Chives',
        latin: 'Allium schoenoprasum',
        price: 9,
        category: 'Herbs',
        description: 'Allium schoenoprasum, commonly called chives, is a small bulbous perennial which iscommonly used as a culinary herb to impart mild onion flavor to many foods.'
    },
    {
        id: 11,
        name: 'Rose',
        latin: 'Rosa',
        price: 6,
        category: 'Flowers',
        description: 'Beautiful flowers, which range in colour from white through various tones of yellow and pink to dark crimson and maroon.'
    },
    {
        id: 12,
        name: 'Tulip',
        latin: 'Tulipa',
        price: 6,
        category: 'Flowers',
        description: 'Flowers are available in a range of colors including pink, red, yellow, light yellow cream, white, and orange.'
    },
    {
        id: 13,
        name: 'Sunflower',
        latin: 'Helianthus',
        price: 12,
        category: 'Flowers',
        description: 'Sunflowers are native primarily to North and South America, and some species are cultivated as ornamentals for their spectacular size and flower heads and for their edible seeds.'
    },
    {
        id: 14,
        name: 'Daffodil',
        latin: 'Narcissus',
        price: 4,
        category: 'Flowers',
        description: 'Daffodils. Daffodils are often refereed to as Narcissus, named after the mythological boy, Narcissus, who loved to admire his own beauty.'
    },
    {
        id: 15,
        name: 'Marigold',
        latin: 'Tagetes',
        price: 5,
        category: 'Flowers',
        description: 'It flowers from July to September. The scented flowers are hermaphrodite (have both male and female organs). It is hardy to zone 6 and is frost tender.'
    },
    {
        id: 16,
        name: 'Daisy',
        latin: 'Bellis perennis',
        price: 3,
        category: 'Flowers',
        description: 'Members of the genus Bellis are perennials that have solitary flower heads borne on long stalks; the disk flowers are yellow, the ray flowers white or purple.'
    },
    {
        id: 17,
        name: 'Orchid',
        latin: 'Orchidaceae',
        price: 5,
        category: 'Flowers',
        description: 'Orchid flowers have three sepals and three petals. The three sepals and two of the petals are often similar to each other but one petal is usually highly modified, forming a "lip" or labellum.'
    },
    {
        id: 18,
        name: 'Carnations',
        latin: 'Dianthus caryophyllus',
        price: 4,
        category: 'Flowers',
        description: 'Carnation, (Dianthus caryophyllus), also called grenadine or clove pink, herbaceous plant of the pink, or carnation, family (Caryophyllaceae), native to the Mediterranean area.'
    },
    {
        id: 19,
        name: 'Gerberas',
        latin: 'Gerbera',
        price: 2,
        category: 'Flowers',
        description: 'Gerbera jamesonii is a species of flowering plant in the genus Gerbera belonging to the basal Mutisieae tribe within the large Asteraceae family.'
    },
    {
        id: 20,
        name: 'Jasmine',
        latin: 'Jasminum',
        price: 3,
        category: 'Flowers',
        description: 'Jasmine or Jessamine is any of the more than two hundred species of shrubs and vines comprising the plant genus Jasminum of the olive family (Oleaceae).'
    },
    {
        id: 21,
        name: 'ZZ Plant',
        latin: 'Zamioculcas Zamiifolia',
        price: 12,
        category: 'House Plants',
        description: 'The perfect plant for living in a lower-light environment, and it doesn’t attract bugs or pests. It has rhizomes to help it store water and survive droughts, so it only needs to be watered three times per month.'
    },
    {
        id: 22,
        name: 'Dracaena',
        latin: 'Dracaena',
        price: 11,
        category: 'House Plants',
        description: 'This plant can thrive in all levels of light, but it’s best to keep it out of direct sunlight. Because of its easy maintenance, having a dracaena plant will feel more like a decoration and less like something you need to take care of.'
    },
    {
        id: 23,
        name: 'Pothos',
        latin: 'Epipremnum aureum',
        price: 9,
        category: 'House Plants',
        description: 'Pothos, also sometimes called devil’s ivy, golden pothos, or hunter’s rove, is one of the most popular house plants in North America. These plants can be hung from a basket, and its vines can grow over 10 feet long.'
    },
    {
        id: 24,
        name: 'Rubber Tree',
        latin: 'Ficus elastica',
        price: 8,
        category: 'House Plants',
        description: 'The rubber tree can handle some underwatering and neglect, but make sure to give it as much sunlight as it can get. That way, it can grow and serve its purpose of filtering carbon dioxide out of your home.'
    },
    {
        id: 25,
        name: 'Fiddle-Leaf Fig',
        latin: 'Ficus lyrata',
        price: 12,
        category: 'House Plants',
        description: 'The fiddle-leaf fig has more appeal than just a cool name. It’s known for its tall, dark green leaves that can brighten up any boring room. The fiddle-leaf fig can grow in most bright locations and only needs to be watered when the soil is dry.'
    },
    {
        id: 26,
        name: 'Zebra Plant',
        latin: 'Aphelandra squarrosa',
        price: 13,
        category: 'House Plants',
        description: 'Named for its striped leaves, the zebra plant can thrive in low light locations with minimal watering. Because of its compact size, the striped plant is the perfect addition to any kitchen or bathroom.'
    },
    {
        id: 27,
        name: 'Jade Plant',
        latin: 'Crassula ovata',
        price: 11,
        category: 'House Plants',
        description: 'The jade plant may be perfect for you! It’s a succulent native to South Africa, and is known for retaining water all year-round. If they don’t get enough water, jade plants go dormant and stop growing.'
    },
    {
        id: 28,
        name: 'Philodendron',
        latin: 'Philodendron',
        price: 11,
        category: 'House Plants',
        description: 'The philodendron is a plant popular across the world and in homes around the country. It likes being on the dry side, so you only need to water it once a week. You can take care of it by monitoring how it responds to its environment.'
    },
    {
        id: 29,
        name: 'Aloe Vera',
        latin: 'Aloe vera',
        price: 8,
        category: 'House Plants',
        description: 'Homeowners love their aloe vera plants because they act as beautiful decorations and useful healers. The aloe inside the plant has anti-inflammatory and anti-bacterial properties that can be used on scrapes and wounds.'
    },
    {
        id: 30,
        name: 'Yucca',
        latin: 'Yucca',
        price: 11,
        category: 'House Plants',
        description: 'If you have a personality that radiates happiness and sunshine, the yucca will be your perfect match. The key to taking care of a yucca plant is giving it as much sun as it can get and watering it sparingly.'
    },
];